import {
  DocumentVerificationResult,
  IdentityVerificationDocument,
  IdentityDocumentVerificationStatus,
  TransformedIdentityVerificationDocument,
} from '@afterpaytouch/portal-api/identity/types'

export const toVerifiedDocument = (documentVerificationResults: DocumentVerificationResult[]): IdentityVerificationDocument[] =>
  documentVerificationResults.reduce<IdentityVerificationDocument[]>((acc, item) => {
    if (item.status === IdentityDocumentVerificationStatus.VERIFIED) {
      return [...acc, item.type]
    }
    return acc
  }, [])
export const transformIdentityDocument = (identityVerificationDocument: IdentityVerificationDocument[]): TransformedIdentityVerificationDocument[] => {
  return identityVerificationDocument.map((doc) => {
    if (doc === IdentityVerificationDocument.LICENCE) {
      const splitDoc = doc.split('_')
      if (splitDoc[1]) {
        return splitDoc[1].toLowerCase() as TransformedIdentityVerificationDocument
      }
      // Handle the case where splitDoc[1] is undefined
      return '' as TransformedIdentityVerificationDocument
    }
    return doc.toLowerCase() as TransformedIdentityVerificationDocument
  })
}
